<form clrStepper [formGroup]="deliveryForm">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Empfänger</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content *clrIfExpanded>

      <app-request-company-search (submitSupplierNumber)="preFillRow($event)"></app-request-company-search>

      <clr-input-container>
        <label>Firma</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Abteilung</label>
        <input clrInput name="department" formControlName="department" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />

      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ deliveryForm.value.delivery_date | date: 'dd.MM.yyyy' }}" formControlName="delivery_date" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="deliveryForm.get('stepI')?.invalid">Weiter</button>
        <button class="btn btn-danger" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/delivery/details', projectId, jobId, deliveryId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <div>Projektnummer {{ projectId }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label [class.leader]="employee.staff_id === projectLeader()">
            <ng-container *ngIf="employee.staff_id === projectLeader(); else defaultName">
              <b>{{ employee.firstname }} {{ employee.lastname }}</b>
            </ng-container>
            <ng-template #defaultName>{{ employee.firstname }} {{ employee.lastname }}</ng-template>
          </label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next" [disabled]="deliveryForm.get('stepII')?.invalid">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/project/details', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/delivery/details', projectId, jobId, deliveryId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Empfänger)</clr-step-description>
    <clr-step-content *clrIfExpanded>
      <select clrSelect formControlName="employee_leader">
        <option></option>
        <option *ngFor="let person of persons" value="{{ person.pid }}">{{ person.lastname }}, {{ person.firstname }}</option>
      </select>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit" [disabled]="deliveryForm.invalid" (click)="updateDelivery()">Änderungen speichern</button>
        <button class="btn btn-warning-outline btn-sm" [routerLink]="['/delivery/details', projectId, jobId, deliveryId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ deliveryForm.value | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ deliveryData | json }}
</pre>
